import 'uplot/dist/uPlot.min.css';
import React from "react";
import SearchContent from "./SearchContent";

export default function Searchpage() {
    return (
        <SearchContent/>
    );
}
